import { useEffect, useReducer } from 'react';
import { getFontsArr, getUseFonts } from '../utils/FontsUtil';

const initState = { data: null, complete: false, error: null };

const reducer = (state, action) => {
  switch (action.type) {
    case 'loading':
      return { data: null, complete: false, error: null };
    case 'result':
      return { data: action.data, complete: true, error: null };
    case 'error':
      return { data: null, complete: true, error: action.error };
    default:
      return {};
  }
};

export function useExtFontsData() {
  const isUseFont = getUseFonts();

  const [{ data, complete, error }, dispatch] = useReducer(reducer, initState);
  function run() {
    if (complete) dispatch({ type: 'loading' });
    if (isUseFont) {
      getFontsArr()
        .then((data) => dispatch({ type: 'result', data }))
        .catch((error) => dispatch({ type: 'error', error }));
    } else {
      dispatch({ type: 'result', data: [] });
    }
  }
  useEffect(() => {
    run();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return { data, complete, error };
}
